import { Box, Checkbox, createTheme, Grid, Paper, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, ThemeProvider } from "@mui/material";
import { esES } from "@mui/material/locale";
import { useState } from "react";

const theme = createTheme( {
        palette: {  primary: { main: '#1976D2' }, },
    },
    esES,
);


export const AjustesMovimientos = (props) => {
    const {ajustes} = props;

 

    return (
        <Grid>
        <Box sx={{Width: '100%', marginTop:'0px'}}>
            <TableContainer component={Paper}>
            <ThemeProvider theme={theme}>
            <Table aria-label="simple table" size='small'>
            <TableHead>
                <TableRow  sx={{ bgcolor:'#1976D2'}}>
                    <TableCell sx={{ color: 'white' }} >
                        <strong>Tipo</strong>
                    </TableCell>
                    <TableCell align='center' sx={{ color: 'white' }} >
                        <strong>Banco</strong>
                    </TableCell>
                    <TableCell align='center' sx={{ color: 'white' }} >
                        <strong>Monto</strong>
                    </TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {
                    ajustes && ajustes.map((item, id) =>(
                        <TableRow key={id}>
                            <TableCell component="th" scope="row">
                                {item.tipo_movimiento}
                            </TableCell>
                            <TableCell align='center' component="th" scope="row">
                               {item?.banco}
                            </TableCell>
                            <TableCell align='center' component="th" scope="row">
                               $ {item?.monto}
                            </TableCell> 
                        </TableRow>
                    ))
                }
            </TableBody>
            </Table>
            </ThemeProvider>
            </TableContainer>
        </Box>
    </Grid>
    );
}